import {isArrayNullUndefinedOrEmpty, isNullOrUndefined} from "../../../services/Validator";
import SystemFullScreenError from "../../../components/errors/SystemFullScreenError";
import {kExerciserResultsError} from "../../../constants/errors";
import ExerciserResultsTabletSummary from "../../../components/others/courses/exercisers/ExerciserResultsTabletSummary";
import SystemLeaveFlashDialog from "../../../components/dialogs/SystemLeaveFlashDialog";
import ExerciserResultsDesktopTopBar from "../../../components/bars/courses/exercisers/ExerciserResultsDesktopTopBar";
import ExerciserResultsTabletTopBar from "../../../components/bars/courses/exercisers/ExerciserResultsTabletTopBar";
import SystemExistingFlashSnackBar from "../../../components/snackbars/SystemExistingFlashSnackBar";
import ExerciserResultsDesktopGraphCard
    from "../../../components/cards/courses/exercisers/ExerciserResultsDesktopGraphCard";
import ExerciserResultsTabletQuestionsCard
    from "../../../components/cards/courses/exercisers/ExerciserResultsTabletQuestionsCard";
import ExerciserResultsDesktopScoreCard
    from "../../../components/cards/courses/exercisers/ExerciserResultsDesktopScoreCard";
import ExerciserResultsDesktopQuestionsCard
    from "../../../components/cards/courses/exercisers/ExerciserResultsDesktopQuestionsCard";
import ExerciserResultsContentLayout
    from "../../../components/layouts/courses/exercisers/ExerciserResultsContentLayout";
import ExerciserResultsTabletContentLayout
    from "../../../components/layouts/courses/exercisers/ExerciserResultsTabletContentLayout";
import ExerciserResultsDesktopContentLayout
    from "../../../components/layouts/courses/exercisers/ExerciserResultsDesktopContentLayout";
import ExerciserResultsDesktopSummaryLayout
    from "../../../components/layouts/courses/exercisers/ExerciserResultsDesktopSummaryLayout";

export default function ExerciserResultsScreen({ isLeaveModalOpen,
                                                 setIsLeaveModalOpen,
                                                 onLeaveExerciserPressed,
                                                 leaveExerciser,
                                                 problem,
                                                 isSnackbarOpen,
                                                 handleClose }) {
    // Used in Exerciser to display exercisers end results

    // PROPERTIES
    const totalQuestions = problem?.questions?.length

    // BUILD
    if (isArrayNullUndefinedOrEmpty(problem))
        return <SystemFullScreenError error={kExerciserResultsError} />
    return (
        <div className="overflow-auto animate-appear w-full h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center">
            {/** SNACKBAR */}
            <SystemExistingFlashSnackBar open={isSnackbarOpen}
                                         handleClose={handleClose} />
            {/** ---- MODAL */}
            <SystemLeaveFlashDialog open={isLeaveModalOpen}
                                    handleClose={() => setIsLeaveModalOpen(false)}
                                    leave={leaveExerciser} />
            {/** TOP BARS */}
            <ExerciserResultsDesktopTopBar onLeaveExerciserPressed={onLeaveExerciserPressed} />
            <ExerciserResultsTabletTopBar onLeaveExerciserPressed={onLeaveExerciserPressed} />
            {/** CORE */}
            <ExerciserResultsContentLayout>
                {/** ---- TABLET */}
                <ExerciserResultsTabletContentLayout>
                    <ExerciserResultsTabletSummary scores={computeExerciserScores()[0]}
                                                   total={totalQuestions} />
                    <ExerciserResultsTabletQuestionsCard questions={problem?.questions} />
                </ExerciserResultsTabletContentLayout>
                {/** ---- DESKTOP */}
                <ExerciserResultsDesktopContentLayout>
                    <ExerciserResultsDesktopSummaryLayout>
                        <ExerciserResultsDesktopScoreCard scores={computeExerciserScores()[0]}
                                                          total={totalQuestions} />
                        <ExerciserResultsDesktopGraphCard scores={computeExerciserScores()[0]} />
                    </ExerciserResultsDesktopSummaryLayout>
                    <ExerciserResultsDesktopQuestionsCard questions={problem?.questions} />
                </ExerciserResultsDesktopContentLayout>
            </ExerciserResultsContentLayout>
        </div>
    )

    // METHODS
    // ---- Compute exercisers scores
    function computeExerciserScores() {
        // Prepare
        let scores = [0, 0]
        // Compute
        for (let i = 0; i < problem?.questions.length; i++) {
            // Scores
            if (isNullOrUndefined(problem.questions[i].userSubmission)) {
                // Case : userAnswer not found
                scores[1] += 1
            } else {
                // Case : userAnswer found
                problem.questions[i].userSubmission.isCorrect ? scores[0] += 1 : scores[1] += 1
            }
        }
        // Return
        return [scores]
    }
}